import React, {useEffect} from 'react';
import { Navigation } from '../Navigation';

export const UsersNavigation = (props) => {
    return <Navigation title="System" icon="cogs" menu={
            [
                {
                    caption: 'Benutzerverwaltung',
                    icon: 'users',
                    active: true
                }
            ]
        } breadcrumb={[
            {
                caption: 'System',
                href: "/"
            },
            {
                caption: 'Benutzer',
                href: '/system/users'
            },
            ...(typeof props.user !== 'undefined')?[{
                caption: props.user,
                href: '/system/users/' + props.user
            }]:[]
        ]}>{props.children}</Navigation>
}